// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__C1kW_","gridHeader":"grid_gridHeader__ABMDh"};